import { Checkbox } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { VarmesentralRadio } from '../../common/varmesentralRadio';
import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../../types';
import { ServiceSisteToArRadio } from '../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../common/varmesystemBruk';
import { useBioenergiValidation } from '../useBioenergiValidation';
import { InstallertIOppvarmetRomRadio } from '../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const BiokaminMedVannkappeCheckbox = () => {
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateBioenergiSelection } = useBioenergiValidation();

  const biokaminMedVannkappeSelected = watch('bioenergi.value.kaminMedVannbarenVarme.selected');
  const oppvarmingBrukSelection = watch(`bioenergi.value.kaminMedVannbarenVarme.value.bruk`);
  const showVarmesentral = oppvarmingBrukSelection?.romoppvarming;

  const error = formState.errors.bioenergi?.value?.kaminMedVannbarenVarme?.selected;

  return (
    <StyledCard isActive={biokaminMedVannkappeSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!error}
          label={t('bioenergi.bioOvnMedVannkappe.label')}
          {...register('bioenergi.value.kaminMedVannbarenVarme.selected', {
            validate: validateBioenergiSelection,
            deps: ['bioenergi.value.kjel.selected', 'bioenergi.value.kamin.selected'],
            shouldUnregister: true
          })}
        />
        {biokaminMedVannkappeSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name={`bioenergi.value.kaminMedVannbarenVarme.value.varmesentral`}
              translationKeyPrefix={`form.oppvarming.bioenergi.bioOvnMedVannkappe.installasjonsAr`}
            />
            <VarmesentralRadio name="bioenergi.value.kaminMedVannbarenVarme.value.varmesentral.varmesentralType" />
            <InstallertIOppvarmetRomRadio name="bioenergi.value.kaminMedVannbarenVarme.value.varmesentral.installertIOppvarmetRom" />

            <InstallasjonsArRadio
              name={`bioenergi.value.kaminMedVannbarenVarme.value`}
              translationKeyPrefix={`form.oppvarming.bioenergi.bioOvnMedVannkappe.installasjonsAr`}
            />

            <ServiceSisteToArRadio name="bioenergi.value.kaminMedVannbarenVarme.value.serviceGjennomfortSiste2Ar" />

            <VarmesystemBrukCheckboxes name="bioenergi.value.kaminMedVannbarenVarme.value.bruk" />

            {showVarmesentral && <Fordelingssystem />}
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
